module.exports = __webpack_public_path__ + "img/users-and-members.137284db.svg";